import { Navigate, useParams } from "react-router";

/** 旧「可进入人员」独立页：跳回代管授权「收到的授权」，并打开分配弹窗。 */
export default function AssigneesPage() {
  const { accountId, authorizationId } = useParams();
  const search = new URLSearchParams({ tab: "received" });
  if (authorizationId) search.set("assign", authorizationId);
  return <Navigate to={`/accounts/${accountId}/authorizations?${search.toString()}`} replace />;
}
